import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { API, fileApi } from '../lib/api';
import { formatDateTime } from '../lib/brand';

export default function AdminDocuments() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data: cases } = await API.get('/admin/cases');
        const all = [];
        for (const c of cases) {
          try {
            const { data: fs } = await API.get(`/files/case/${c.id}`);
            for (const f of fs) {
              all.push({ ...f, case_number: c.case_number, customer: `${c.person.first_name} ${c.person.last_name}` });
            }
          } catch (e) { /* ignore */ }
        }
        all.sort((a, b) => (a.created_at < b.created_at ? 1 : -1));
        setItems(all);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="space-y-4" data-testid="admin-documents">
      <h1 className="font-heading font-semibold text-2xl text-[hsl(var(--primary))]">Dokumente</h1>
      <Card className="rounded-2xl border-slate-200">
        <CardContent className="p-0">
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="admin-documents-table">
              <thead className="bg-slate-50"><tr className="text-left text-slate-600"><th className="px-4 py-3">Datei</th><th className="px-4 py-3">Kategorie</th><th className="px-4 py-3">Fall</th><th className="px-4 py-3">Kunde</th><th className="px-4 py-3">Erstellt</th><th className="px-4 py-3"></th></tr></thead>
              <tbody>
                {loading ? <tr><td colSpan={6} className="px-4 py-6 text-slate-500">Lade...</td></tr> : items.length === 0 ? <tr><td colSpan={6} className="px-4 py-6 text-slate-500">Keine Dokumente.</td></tr> : items.map((d) => (
                  <tr key={d.id} className="border-t border-slate-100 hover:bg-slate-50">
                    <td className="px-4 py-3 truncate max-w-[260px]">{d.filename}</td>
                    <td className="px-4 py-3">{d.category}</td>
                    <td className="px-4 py-3 font-mono text-xs">{d.case_number}</td>
                    <td className="px-4 py-3">{d.customer}</td>
                    <td className="px-4 py-3 text-slate-500">{formatDateTime(d.created_at)}</td>
                    <td className="px-4 py-3 text-right"><a className="text-[hsl(var(--primary))] underline" href={fileApi.url(d.id)} target="_blank" rel="noreferrer">Ansehen</a></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
